// 横スクロール用の汎用実装
function initScrollbar(selector = '[data-scrollbar="horizontal"]', options = {}) {
	const config = {
		direction: 'horizontal', // 'horizontal' or 'vertical'
		...options
	};

	const elements = document.querySelectorAll(selector);
	
	elements.forEach((element) => {
		// スクロールバークラスを追加
		element.classList.add('c-custom-scrollbar');
		
		if (config.direction === 'horizontal') {
			element.classList.add('c-custom-scrollbar--horizontal');
			initHorizontalScrollbar(element);
		}
	});
}

function initHorizontalScrollbar(element) {
	const scrollContent = element.querySelector('[data-scroll-content]');
	function updateScrollProgress() {
		const scrollWidth = scrollContent.scrollWidth;
		const clientWidth = scrollContent.clientWidth;
		const scrollLeft = scrollContent.scrollLeft;

		if (scrollWidth > clientWidth) {
			element.classList.remove('c-custom-scrollbar--hidden');
			const scrollPercentage = (scrollLeft / (scrollWidth - clientWidth)) * 100;
			element.style.setProperty('--scroll-progress', `${Math.min(Math.max(scrollPercentage, 0), 100)}`);
		} else {
			element.classList.add('c-custom-scrollbar--hidden');
		}
	}

	// 初期設定
	updateScrollProgress();

	// スクロールイベントリスナー
	scrollContent.addEventListener('scroll', updateScrollProgress);

	// マウスホイールによる横スクロール制御
	if (!scrollContent.dataset.mouseScrollInit && scrollContent.dataset.noScrollPc !== 'true') {
		scrollContent.addEventListener('wheel', (e) => {
			// 縦スクロールのイベントを横スクロールに変換
			if (e.deltaY !== 0) {
				e.preventDefault();
				scrollContent.scrollLeft += e.deltaY;
			}
		}, { passive: false });
		
		// 初期化済みマークを追加
		scrollContent.dataset.mouseScrollInit = 'true';
	}

	// リサイズイベントリスナー（レスポンシブ対応）
	window.addEventListener('resize', updateScrollProgress);
}